const TERMINAL = new Set([
    'ready',
    'failed'
]);
export function isTerminal(status) {
    return TERMINAL.has(status);
}
export function taskFromJob(job) {
    var _ref;
    const data = job.data;
    return {
        jobId: job.jobId,
        kind: 'relationshipPdf',
        status: job.status,
        progress: job.progress,
        updatedAt: job.updatedAt,
        seen: job.seen,
        agreementName: (_ref = data === null || data === void 0 ? void 0 : data.agreementName) !== null && _ref !== void 0 ? _ref : '',
        relationshipId: data === null || data === void 0 ? void 0 : data.relationshipId,
        downloadUrl: data === null || data === void 0 ? void 0 : data.downloadUrl,
        fileName: data === null || data === void 0 ? void 0 : data.fileName,
        error: job.error
    };
}
